import { isPhoneIdentityEmail } from "@/lib/core/auth-protocol";

type GoogleLinkStatus = "pending" | "failed" | "linked" | "unlinked";

export type LoginSecurityView =
    | { kind: "loading" }
    | { kind: "guest" }
    | {
          kind: "member";
          identity: string;
          google: GoogleLinkStatus;
      };

export function accountIdentityLabel(user: { email: string }) {
    return isPhoneIdentityEmail(user.email)
        ? "Signed in with your phone number"
        : `Signed in as ${user.email}`;
}

type LinkedProvidersLookup = {
    data?: readonly string[];
    isError: boolean;
    isFetching: boolean;
};

function googleLinkStatus({
    data,
    isError,
    isFetching,
}: LinkedProvidersLookup): GoogleLinkStatus {
    if (data) return data.includes("google") ? "linked" : "unlinked";
    return isError && !isFetching ? "failed" : "pending";
}

export function loginSecurityView({
    isLoaded,
    isSignedIn,
    user,
    linkedProviders,
}: {
    isLoaded: boolean;
    isSignedIn: boolean;
    user: { email: string } | null;
    linkedProviders: LinkedProvidersLookup;
}): LoginSecurityView {
    if (!isLoaded) return { kind: "loading" };
    if (!isSignedIn || !user) return { kind: "guest" };
    return {
        kind: "member",
        identity: accountIdentityLabel(user),
        google: googleLinkStatus(linkedProviders),
    };
}
